import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import MessageDialog from '@/components/core/dialogs/MessageDialogModal.vue';

function ConfirmDialog({ message, showOkBtn = true, modalWidth = '300' }) {
	// let dummy=message;dummy=yesBtnText;dummy=noBtnText;JSON.stringify(dummy) //because eslint config
	let modal = document.createElement('div');
	document.body.appendChild(modal);
	return new Promise((resolve) => {
		let vModal = new Vue({
			vuetify,
			el: modal,
			components: {
				MessageDialog,
			},
			data: {
				showDialog: true,
				showOkBtn,
				message,
				modalWidth,
			},
			methods: {
				kill() {
					modal = vModal.$el;
					vModal.$destroy();
					if (modal.parentNode) {
						modal.parentNode.removeChild(modal);
					}
				},
				onOk() {
					this.showDialog = false;
					resolve(1);
					this.kill();
				},
			},
			template: `<message-dialog :showDialog="showDialog" :showOkBtn="showOkBtn" :modalWidth="modalWidth":message="message" @ok="onOk" />`,
		});
	});
}

export default ConfirmDialog;
